import { render, staticRenderFns } from "./usps.vue?vue&type=template&id=02aebfaa"
import script from "./usps.vue?vue&type=script&lang=js"
export * from "./usps.vue?vue&type=script&lang=js"
import style0 from "./usps.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports